import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MessageCircle, RefreshCw, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { nowPeriod } from "@/lib/format";
import { EmptyState, PageHeader, PeriodSelect, btnGhost, btnPrimary } from "@/components/app/common";
import { DatiInsufficienti, InsightItem, InsightsMeta, InsightsState, useInsights } from "@/components/app/Insights";

export default function Consulente() {
  const [params] = useSearchParams();
  const now = nowPeriod();
  const m = params.get("mese");
  const [period, setPeriod] = useState({ anno: Number(params.get("anno")) || now.anno, mese: m === "all" ? null : Number(m) || now.mese });
  const s = useInsights(period.anno, period.mese);
  const items = s.data?.insights || [];

  return (
    <div data-testid="consulente-page">
      <PageHeader overline="Consulente AI" title="Consigli automatici" subtitle="L'AI legge solo i numeri calcolati dall'app (incassi, costi, margini, magazzino, budget) e ti suggerisce cosa controllare, dove investire o tagliare.">
        <PeriodSelect anno={period.anno} mese={period.mese} onChange={setPeriod} allowYear prefix="consulente" />
        <Button variant="outline" className={btnGhost} onClick={s.regenerate} disabled={s.loading} data-testid="consulente-regenerate-button"><RefreshCw className="h-4 w-4 mr-1" />Rigenera</Button>
        <Link to="/consulente/chat" className={`${btnPrimary} inline-flex items-center gap-2`} data-testid="consulente-chat-link"><MessageCircle className="h-4 w-4" />Chiedi al consulente</Link>
      </PageHeader>
      <InsightsState s={s} rows={4} />
      {!s.loading && !s.error && (
        <>
          <InsightsMeta data={s.data} />
          <DatiInsufficienti d={s.data?.dati_insufficienti} label={s.data?.periodo_label} />
          {!items.length && <EmptyState icon={Sparkles} title="Nessun consiglio verificabile" text="Completa i dati indicati sopra o premi Rigenera." />}
          {items.length > 0 && (
            <div className="grid lg:grid-cols-2 gap-5" data-testid="consulente-insights-list">
              {items.map((it, i) => <InsightItem key={i} it={it} i={i} />)}
            </div>
          )}
        </>
      )}
    </div>
  );
}
